// extracted by mini-css-extract-plugin
module.exports = {"group":"ColorFieldConfigurator_group__s9Sel","color":"ColorFieldConfigurator_color__g1zNj","input":"ColorFieldConfigurator_input__1SMrt"};